export enum PageType {
  Facebook = 'facebook',
  Instagram = 'instagram'
}
